import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {forkJoin, Observable, Subscription} from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {Offset} from '../../../models/Offset';
import {NumAnnoMeseService} from '../../general-services/service-num-anno-mese/num-anno-mese.service';
import {LoaderService} from '../../general-services/service-loader/loader.service';
import {GenericArray} from '../../../models/GenericArray';
import {DialogDetailComponent} from '../../general-components/dialog-detail/dialog-detail.component';
import {ChargesScartoService} from './service-charges-scarto/charges-scarto.service';
import {ScartiConsuntivoChargesModel} from '../../../models/ScartiConsuntivoChargesModel';
import {BaseGeneralComponent} from '../../BaseGeneralComponent';
import {ProviderAnagrafService} from '../../general-services/service-provider-anagraf/provider-anagraf.service';
import {Router} from '@angular/router';
import {ProviderModel} from '../../../models/ProviderModel';
import { debounceTime, delay, tap } from 'rxjs/operators';

@Component({
  selector: 'app-charges-waste',
  templateUrl: './waste-charges.component.html',
  styleUrls: ['./waste-charges.component.scss']
})
export class WasteChargesComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  getPageSubscribe: Subscription;
  deleteElementSubscribe: Subscription;
  // getFirstYearSubscribe: Subscription;
  getFirstYearObservable: Observable<any>;
  getFirstProviderObservable: Observable<any>;
  numYearMonthData: any;

  displayedColumns: Array<string>;
  dataSource: any;
  isMocked: boolean;
  showFilter = true;
  listData: MatTableDataSource<any>;
  offset: Offset;
  // numAnnoMese: any;
  filter: ScartiConsuntivoChargesModel;

  isConsumptiveWasteSection: boolean;
  selectedRowIndex: number;

  providerSelected: ProviderModel;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @Input() reportSection?: boolean;
  @Output() elementSelected = new EventEmitter();



  constructor(private numYearMonthService: NumAnnoMeseService,
              private providerService: ProviderAnagrafService,
              private wasteChargesService: ChargesScartoService,
              private dialog: MatDialog,
              private loaderService: LoaderService,
              private router: Router) {
    super();
    this.providerSelected = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED)) as ProviderModel;

    if (this.providerSelected.description === this.PROVIDER_IBM || this.providerSelected.description.includes(this.PROVIDER_KYN)) {
      this.displayedColumns = ['numAnnoMeseRif', 'providerCod', 'regionCod',
        'localCustomerCod', 'contractCod', 'resourcesUnitCod',
        'designedServiceCod', 'charge', 'errors', 'actions'];
    } else {
      this.displayedColumns = ['billedMonth', 'numAnnoMeseRif', 'providerCod',
        'regionCod', 'localCustomerCod', 'contractCod',
        'resourcesUnitCod', 'designedServiceCod', 'numAnnoMeseAcceptance', 'residualMonth',
        'percUse', 'applicableRate', 'charge', 'errors', 'actions'];
    }
  }

  ngOnInit() {
    this.isConsumptiveWasteSection = this.returnIsContractSection(this.router.url);
    this.selectedRowIndex = -1;
    this.offset = this.setOffsetInSession(this.offset, this.OFFSET_NAME.SCARTI_CONSUNTIVO_CHARGES_OFFSET);
    this.filter = new ScartiConsuntivoChargesModel();
    this.getFirstYearObservable = this.numYearMonthService.getAllMonth(this.providerSelected).pipe();
    this.getFirstProviderObservable = this.providerService.getAll(this.providerService.baseUrl, null).pipe();
    this.manageForkJoin(this.getFirstYearObservable, this.offset);
  }

  manageForkJoin(getFirstYearSubscribe: Observable<any>, offset: Offset) {
    forkJoin([getFirstYearSubscribe]).subscribe(
        (resultFork: any) => {
            const providerDefault =
              JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED)) as ProviderModel;
            this.numYearMonthData = this.filterFromDxc(providerDefault, resultFork[0] ? resultFork[0] : null);

            if (!this.filter.numAnnoMese) {
              this.numYearMonthService.getLastConsumptiveVolMonth(this.providerSelected).subscribe(
                res => {
                  this.filter.numAnnoMese = res;
                  this.getDataPage(this.offset, this.filter);
                  if (this.reportSection) {
                    this.showFilter = true;
                  }
                }
              );
            } else {
              if (!this.reportSection) {
                // this.showFilter = false;
                this.getDataPage(this.offset, this.filter);
              } else {
                this.showFilter = true;
              }
            }          },
              error => {
                console.log(error);
                this.loaderService.display(false);
              });
  }

  getDataPage(offset: Offset, filter: ScartiConsuntivoChargesModel) {
    this.loaderService.display(true);
    this.getPageSubscribe = this.wasteChargesService.getPage(offset, filter)
    .pipe(
      tap(() => this.loaderService.display(true)),
      debounceTime(0),
      delay(0),
      tap(() => this.loaderService.display(false)),
    ).subscribe(
        (resultPage: any) => {
          this.dataSource = resultPage.content;
          this.listData = new MatTableDataSource(this.dataSource);
          this.paginator.pageIndex = offset.pageIndex;
          this.paginator.showFirstLastButtons = true;
          this.paginator.length = resultPage.totalElements;
          this.listData.sort = this.sort;
          this.loaderService.display(false);
        });
  }

  openDialog(id: number) {
    const consumptiveCharges = this.dataSource.find(data => data.id === id) as ScartiConsuntivoChargesModel;
    const list: GenericArray[] = [
      {id: 'Month', value: this.toCustomStringAnnoMese(consumptiveCharges.numAnnoMese)},
      {id: 'Reference Month', value: this.toCustomStringAnnoMese(consumptiveCharges.numAnnoMeseRif)},
      {id: 'Region Cod', value: this.toCustomString(consumptiveCharges.regionCod)},
      {id: 'Local Customer Cod', value: this.toCustomString(consumptiveCharges.localCustomerCod)},
      {id: 'Contract Type Cod', value: this.toCustomString(consumptiveCharges.contractCod)},
      {id: 'Resource Unit Cod', value: this.toCustomString(consumptiveCharges.resourcesUnitCod)},
      {id: 'Errors', value: this.toCustomString(consumptiveCharges.errors)},
      {id: 'SL1 Cod', value: this.toCustomString(consumptiveCharges.designedServiceCod)},
    ];
    this.dialog.open(DialogDetailComponent, {
      width: '40%',
      data: {list}
    });
  }

  getNext(event: PageEvent) {
    this.loaderService.display(true);
    let tmpOffset = new Offset(event.pageSize, event.pageIndex);
    tmpOffset = this.setOffsetInSession(tmpOffset, this.OFFSET_NAME.SCARTI_CONSUNTIVO_CHARGES_OFFSET);
    tmpOffset.orderDirection = this.offset.orderDirection;
    tmpOffset.orderField = this.offset.orderField;
    this.offset = tmpOffset;
    this.getDataPage(this.offset, this.filter);

  }

  getDataFiltered(dataFiltered: any) {
    this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
    this.filter = dataFiltered;
    if (!this.reportSection) {
      this.getDataPage(this.offset, this.filter);
    }  }

  sortData(sort: Sort) {
    this.loaderService.display(true);
    if ((sort.active !== null || true || sort.active !== '') && (sort.direction !== '' || sort.direction !== null || true)) {
      if (this.offset === null || this.offset === undefined) {
        this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
      }

      this.offset.orderField = sort.active;
      this.offset.orderDirection = sort.direction;

      this.getDataPage(this.offset, this.filter);
    }

  }

  selectRow(row: any) {
    this.selectedRowIndex = row.id;
    this.elementSelected.emit({ row });
  }

  ngOnDestroy(): void {
    if (this.getPageSubscribe) {
      this.getPageSubscribe.unsubscribe();
    }
    if (this.deleteElementSubscribe) {
      this.deleteElementSubscribe.unsubscribe();
    }
  }

  toggleFilter() {
    if (!this.reportSection) {
      this.showFilter = !this.showFilter;
    }
  }
}
